import {
  FETCH_DOCTORS_EARNING,
  FETCH_DOCTORS__EARNING_SUCCESS,
  FETCH_DOCTORS__EARNING_FAILED,
} from "../store/types";

export const fetchBrokerEarnings = (uid,role) => (dispatch) => (firebase) => {

  const {
    bookingListRef
  } = firebase;

  dispatch({
    type: FETCH_DOCTORS_EARNING,
    payload: null
  });
  bookingListRef(uid,role).on("value", snapshot => {
    if (snapshot.val()) {
      const mainArr = snapshot.val();
      var monthsName = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var renderobj = {};
      Object.keys(mainArr).map(j => {
        if ((mainArr[j].status === 'PAID' || mainArr[j].status === 'COMPLETE') && mainArr[j].broker_share !== undefined) {
          let bdt = new Date(mainArr[j].eventdate);
          let uniqueKey = bdt.getFullYear() + '_' + bdt.getMonth() + '_' + mainArr[j].broker;
          if (renderobj[uniqueKey] && renderobj[uniqueKey].brokerShare > 0) {
            renderobj[uniqueKey].brokerShare = parseFloat(renderobj[uniqueKey].brokerShare) + mainArr[j].broker_share;
          } else {
            renderobj[uniqueKey] = {};
            renderobj[uniqueKey]['dated'] = mainArr[j].eventdate;
            renderobj[uniqueKey]['year'] = bdt.getFullYear();
            renderobj[uniqueKey]['month'] = bdt.getMonth();
            renderobj[uniqueKey]['monthsName'] = monthsName[bdt.getMonth()];
            renderobj[uniqueKey]['brokerName'] = mainArr[j].broker_name;
            renderobj[uniqueKey]['brokerShare'] = parseFloat(mainArr[j].broker_share);
            renderobj[uniqueKey]['brokerVehicleNo'] = mainArr[j].vehicle_number;
            renderobj[uniqueKey]['brokerUId'] = mainArr[j].broker;
            renderobj[uniqueKey]['uniqueKey'] = uniqueKey;
          }
        }
        return null;
      });
      if (renderobj) {
        const arr = Object.keys(renderobj).map(i => {
          renderobj[i].brokerShare = parseFloat(renderobj[i].brokerShare).toFixed(2)
          return renderobj[i]
        })
        dispatch({
          type: FETCH_DOCTORS__EARNING_SUCCESS,
          payload: arr
        });
      }

    } else {
      dispatch({
        type: FETCH_DOCTORS__EARNING_FAILED,
        payload: "No data available."
      });
    }
  });
};

